import { BaseError } from '@see-power-pft-common-js/types/base-error';

export interface IAvailabilityDownloadError extends BaseError {
  kind:
    | 'FetchError'
    | 'RequestUnauthorisedError'
    | 'ResponseNotOkError'
    | 'FetchBlobError'
    | 'DownloadError';
}

export class FetchError
  extends BaseError
  implements IAvailabilityDownloadError
{
  kind = 'FetchError' as const;
  constructor(cause: Error) {
    super('Error fetching', { cause });
  }
}
export class RequestUnauthorisedError
  extends BaseError
  implements IAvailabilityDownloadError
{
  kind = 'RequestUnauthorisedError' as const;
  constructor(context: {
    response: Pick<Response, 'status' | 'statusText'> & {
      headers: [string, string][];
    };
  }) {
    super('Request unauthorised', { context });
  }
}
export class ResponseNotOkError
  extends BaseError
  implements IAvailabilityDownloadError
{
  kind = 'ResponseNotOkError' as const;
  constructor(context: {
    response: Pick<Response, 'status' | 'statusText'> & {
      headers: [string, string][];
      bodyText?: string;
    };
  }) {
    let message = 'Failed to download report. Please try again.';

    if (context.response.bodyText) {
      try {
        const body = JSON.parse(context.response.bodyText);
        if (body.message) {
          message = body.message;
        }
      } catch {
        // Keep generic fallback
      }
    }

    super(message, { context });
  }
}
export class FetchBlobError
  extends BaseError
  implements IAvailabilityDownloadError
{
  kind = 'FetchBlobError' as const;
  constructor(cause: Error) {
    super('Error parsing fetch response as blob', { cause });
  }
}
export class DownloadError
  extends BaseError
  implements IAvailabilityDownloadError
{
  kind = 'DownloadError' as const;
  constructor(message: string) {
    super(message);
  }
}
